<template lang="pug">
  div(v-if="usePDFViewerOld && usePDFViewerOld.active && bytes.byteLength >= usePDFViewerOld.minByteLength")
    app-pdf-viewer-old(
      :bytes="bytes"
      :customStyle="customStyle"
    )
  div(v-else)
    div(shadow="hover" :style="customStyle || {}")
      iframe.iframe-container(
        v-if="iframeSrc"
        :src="iframeSrc",
        frameborder="0",
        allowfullscreen,
        :height="height",
        width= "100%"
      )
</template>

<script>
import { mapActions } from 'vuex'
import AppPdfViewerOld from '@/components/AppPDFViewerOld.vue'
const regrasAnalise = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {
  components: {
    AppPdfViewerOld
  },

  props: {
    bytes: {
      required: true,
      type: ArrayBuffer
    },
    customStyle: {
      type: Object
    },
    height: {
      type: String,
      required: false,
      default: '560'
    },
    hideMiniPages: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data () {
    return {
      settings: {
        maxScrollbarLength: 60
      },
      scaleZoomLarger: null,
      scaleZoomPorcentagem: null,
      scaleZoomSmaller: null,
      scaleZoomFrame: null,
      visualizarDocumentosPDF: false,
      usePDFViewerOld: false,
      iframeSrc: null
    }
  },

  methods: {
    ...mapActions({
      resetLoader: 'loader/resetLoader',
      setLoaderWithText: 'loader/setLoaderWithText'
    }),

    async zoomIn () {
      if (this.scaleZoomPorcentagem < 161) {
        this.scaleZoomPorcentagem = await this.scaleZoomPorcentagem + 5
        this.scaleZoomLarger = await (this.scaleZoomPorcentagem * 1.75) / 100
        this.scaleZoomSmaller = await (this.scaleZoomPorcentagem * 1.3) / 100
        this.scaleZoomFrame = await (this.scaleZoomPorcentagem * (window.innerWidth * 0.001)) / 100
      }
      await this.renderPDF()
    },

    async renderPDF () {
      const byteArray = new Uint8Array(this.bytes)
      const blob = new Blob([byteArray], { type: 'application/pdf' })
      this.iframeSrc = URL.createObjectURL(blob)
      if (this.hideMiniPages) {
        this.iframeSrc += '#navpanes=0&pagemode=none&zoom=page-width'
      }
    },

    async zoomOut () {
      if (this.scaleZoomPorcentagem > 30) {
        this.scaleZoomPorcentagem = await this.scaleZoomPorcentagem - 5
        this.scaleZoomLarger = await (this.scaleZoomPorcentagem * 1.75) / 100
        this.scaleZoomSmaller = await (this.scaleZoomPorcentagem * 1.3) / 100
        this.scaleZoomFrame = await (this.scaleZoomPorcentagem * (window.innerWidth * 0.001)) / 100
      }
      await this.renderPDF()
    },

    async rotateLeft () {
      this.rotationAngle -= 90
      if (this.rotationAngle < 0) {
        this.rotationAngle += 360
      }
      await this.renderPDF()
    },

    async rotateRight () {
      this.rotationAngle += 90
      if (this.rotationAngle >= 360) {
        this.rotationAngle -= 360
      }
      await this.renderPDF()
    },

    async resizeHandler (e) {
      await this.renderPDF()
    }
  },
  created () {
    window.addEventListener('resize', this.resizeHandler)
    this.scaleZoomSmaller = 1.3
    this.scaleZoomLarger = 1.75
    this.scaleZoomPorcentagem = 100
    this.scaleZoomFrame = window.innerWidth * 0.001
  },

  destroyed () {
    window.removeEventListener('resize', this.resizeHandler)
  },

  async mounted () {
    this.usePDFViewerOld = regrasAnalise.usePDFViewerOld
    if (!this.usePDFViewerOld || !this.usePDFViewerOld.active || this.bytes.byteLength < this.usePDFViewerOld.minByteLength) {
      this.setLoaderWithText({
        status: true,
        text: 'Carregando dados...'
      })
      await this.renderPDF()
      this.resetLoader()
      this.visualizarDocumentosPDF = regrasAnalise.visualizarDocumentosPDF.active
    }
  },

  watch: {
    bytes: {
      handler (val, oldVal) {
        if (val && val !== oldVal) {
          this.renderPDF()
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/_variables.scss';

#pdf {
  text-align: center;
  margin: 1%;
  border-radius: 15px;
  height: 500px;
  margin-top: 1rem;
  margin-left: 0px;
  margin-right: 0px;
  border: 1px solid #eaeef1;
  width: 100%;
}

.scroll-area {
  position: relative;
  margin: auto;
  height: 100%;
  background-color: transparent;
  border-radius: 15px;
  border: 1px solid #eaeef1;
}

.card-info {
  border-radius: 15px;
  background-color: #4F4F4F;
  border-color: #eaeef1;
  margin: 2%;
}

#card-zoom {
  margin: 0 auto;
  height: 50px;
  margin: -20px 0 -10px;
}

#iconZoom {
  height: 46px;
  margin-top: 5px;
  margin-bottom: 5px;
  background-color: hsl(0, 0%, 50%);
  border-radius: 5px;
}

.zoomIn {
  margin-left: 5px;
}

.zoomOut {
  margin-right: 5px;
  float: right;
}

.rotateLeft, .rotateRight {
  margin: 0 5px;
}

.zoom {
  text-align: center;
  vertical-align: middle;
  color: #D3D3D3!important;
  background-color: #4F4F4F;
  height: 46px;
  padding-top: 15px;
  margin: 5px auto 5px;
  border-radius: 5px;
  margin-right: 10px;
  margin-left: 10px;
}

.fa-search-minus, .fa-search-plus, .fa-undo-alt, .fa-redo-alt {
  color: #fff;
}

>>> canvas {
  border-color: $border-color;
  border-width: 1px;
  border-style: solid;
  margin-bottom: 1rem;
}

@media (max-width: 780px) {
  .porcentagemZoom {
    width: 19%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AppPDFViewer.vue